<div class="card-container">
  <ng-content></ng-content>
</div>
